import { useNavigate, useParams } from 'react-router-dom';
import { ToolsDetails } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { useEffect, useMemo, useState } from 'react';
import { FileInterface, MinioService } from '../../services/api/minio/Minio';
import { CustomAlert } from '../../components/shared';
import { FormFile } from '../../components/custom/files/FormFile';
import { SubNivelAcesso } from '../../services/api/users/UserServices';
import { useAuthContext } from '../../context';
import { helpers } from '../../services/helpers/helpers';

export default function NewFile() {

	const { userData } = useAuthContext();
	const { dam, file } = useParams();
	const [error, setError] = useState<boolean>(false);
	const navigate = useNavigate();
	const [loading, setLoading] = useState<boolean>(false);
	const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
		open: false,
		message: '',
		severity: 'success',
	});

	const [data, setData] = useState<FileInterface>({
		data_emissao: '',
		descricao: '',
		file: null,
		id_barragem: dam ?? '',
		tipo: '',
	});

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.files && e.target.files.length > 0) {
			const selectedFile = e.target.files[0];
			const isPdf = selectedFile.type === 'application/pdf'
				|| selectedFile.name.toLowerCase().endsWith('.pdf');

			if (!isPdf) {
				setAlertInfo({ open: true, message: 'Apenas arquivos PDF são permitidos.', severity: 'warning' });
				e.target.value = '';
				return;
			}

			setData(prevData => ({
				...prevData,
				file: selectedFile,
			}));
		}
	};

	const handleChange = (key: keyof FileInterface, value: string) => {
		setData(prevData => ({
			...prevData,
			[key]: value
		}));
	};

	function verifyFields(data: FileInterface): boolean {
		let fields = '';

		// if (data.data_emissao === '') fields += 'data_emissao, ';
		if (data.file == null) fields += 'file, ';
		if (data.tipo === '') fields += 'tipo, ';

		return fields === '';
	}

	function verifyFieldsUpdate(data: FileInterface): boolean {
		let fields = '';

		// if (data.data_emissao === '') fields += 'data_emissao, ';
		if (data.tipo === '') fields += 'tipo, ';

		return fields === '';
	}

	async function saveFile() {
		setLoading(true);
		setError(false);
		if (file && file !== 'new') {
			if (verifyFieldsUpdate(data)) {
				updateFile(file, data);
			} else {
				setError(true);
				setAlertInfo({ open: true, message: 'Preencha todos os campos! ', severity: 'warning' });
				setLoading(false);
			}
		} else {
			if (verifyFields(data)) {
				try {
					const newObj = structuredClone(data);
					newObj.data_emissao = helpers.mesConvertBR(newObj.data_emissao);
					const response = await MinioService.UploadFile(newObj);
					if (response instanceof Error) {
						setAlertInfo({ open: true, message: 'Erro ao salvar arquivo!', severity: 'error' });
						setLoading(false);
					} else {
						setAlertInfo({ open: true, message: 'Documento criado! ', severity: 'success' });
						setTimeout(() => {
							navigate(-1);
						}, 1000);
					}
				} catch (error) {
					setAlertInfo({ open: true, message: 'Erro ao salvar arquivo! ', severity: 'error' });
					setLoading(false);
					console.log('Erro ao salvar arquivo', error);
				}
			} else {
				setError(true);
				setAlertInfo({ open: true, message: 'Preencha todos os campos! ', severity: 'warning' });
				setLoading(false);
			}
		}
	}

	async function updateFile(uuid: string, data: FileInterface) {
		try {
			const newObj = structuredClone(data);
			newObj.data_emissao = helpers.mesConvertBR(newObj.data_emissao);
			const response = await MinioService.update(uuid, newObj);
			if (response instanceof Error) {
				setAlertInfo({ open: true, message: 'Erro ao atualizar arquivo!', severity: 'error' });
				setLoading(false);
			} else {
				setAlertInfo({ open: true, message: 'Documento ataulizado! ', severity: 'success' });
				setTimeout(() => {
					navigate(-1);
				}, 1000);
			}
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao atualizar arquivo! ', severity: 'error' });
			setLoading(false);
			console.log('Erro ao atualizar arquivo', error);
		}
	}

	async function deletFile(uuid: string) {
		try {
			const response = await MinioService.delet(uuid);
			if (response instanceof Error) {
				setAlertInfo({ open: true, message: 'Erro ao deletar arquivo!', severity: 'error' });
			} else {
				setAlertInfo({ open: true, message: 'Documento deletado! ', severity: 'success' });
				setTimeout(() => {
					navigate(-1);
				}, 1000);
			}
		} catch (error) {
			setAlertInfo({ open: true, message: 'Erro ao deletar arquivo! ', severity: 'error' });
			console.log('Erro ao deletar arquivo', error);
		}
	}


	async function downloadFile() {
		if (file && file !== 'new' && data.url) {
			try {
				await MinioService.downloadFile(data.url, data.nome_arquivo);
			} catch (error) {
				setAlertInfo({ open: true, message: 'Erro ao baixar arquivo!', severity: 'error' });
			}
		}
	}

	useEffect(() => {
		async function fetchData(uuid: string) {
			const response = await MinioService.getMetadados(uuid);
			if (response instanceof Error) {
				setAlertInfo({ open: true, message: 'Falha ao bucar dados! ', severity: 'warning' });
				setTimeout(() => {
					navigate(-1);
				}, 1000);
			} else {
				const objResponse = response as FileInterface;
				objResponse.data_emissao = helpers.mesConvertEUA(objResponse.data_emissao);
				console.table(objResponse);
				setData(objResponse);
			}
		}

		file && file !== 'new' && fetchData(file);
	}, [file]);


	const pagePermissionsString: string | undefined = useMemo(() => {
		const relevantPermissionKey = 'arquivos';
		return userData?.nivel_acesso?.documentacao_tecnica?.[relevantPermissionKey as keyof SubNivelAcesso];
	}, [userData]);

	return (
		<LayoutBase title={'Cadastro de Arquivo'}
			tollBar={
				<ToolsDetails
					onClickSave={saveFile}
					showNewButton={false}
					loading={loading}
					showSaveButton={pagePermissionsString?.includes('add')}
					showDeletButton={pagePermissionsString?.includes('remove')}
					onClickDelet={() => deletFile(file ?? '')}
					disableSave={loading}
				/>
			}
		>
			<FormFile data={data} onFileChange={handleFileChange} onChange={handleChange} error={error} edit={file !== 'new'} download={downloadFile} />
			{alertInfo.open &&
				<CustomAlert
					message={alertInfo.message}
					severity={alertInfo.severity}
					key={alertInfo.message}
				/>
			}
		</LayoutBase>
	);
}